import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { login, logout, checkAuth } from '../services/auth';

// Async thunks
export const loginUser = createAsyncThunk(
  'auth/login',
  async ({ username, password }) => {
    const response = await login(username, password);
    return response.data;
  }
);

export const logoutUser = createAsyncThunk(
  'auth/logout',
  async () => {
    await logout();
  }
);

export const checkAuthStatus = createAsyncThunk(
  'auth/checkStatus',
  async () => {
    const response = await checkAuth();
    return response.data;
  }
);

// Auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: process.env.NODE_ENV === 'development', // Auto-authenticate in development
    user: process.env.NODE_ENV === 'development' ? { username: 'test_user' } : null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Logout
      .addCase(logoutUser.fulfilled, (state) => {
        state.isAuthenticated = false;
        state.user = null;
      })
      // Check auth status
      .addCase(checkAuthStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuthStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = action.payload.authenticated;
        state.user = action.payload.authenticated ? { username: action.payload.username } : null;
      })
      .addCase(checkAuthStatus.rejected, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
      });
  },
});

export const { clearError } = authSlice.actions;
export default authSlice.reducer;